import { render, staticRenderFns } from "./ClientsNewModal.vue?vue&type=template&id=4aab7577&"
import script from "./ClientsNewModal.vue?vue&type=script&lang=js&"
export * from "./ClientsNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports